import { Link } from 'react-router-dom';
import { Sparkles, Award, HeartHandshake } from 'lucide-react';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[#FCFBF9]" data-testid="about-page">
      {/* Breadcrumb */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <nav className="breadcrumb flex items-center gap-2 text-sm">
          <Link to="/" className="hover:text-[#1A1514]">Accueil</Link>
          <span>/</span>
          <span className="text-[#1A1514]">Notre Histoire</span>
        </nav>
      </div>

      {/* Hero */}
      <div className="relative h-[50vh] overflow-hidden bg-[#1A1514]">
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A1514] via-[#1A1514]/90 to-[#1A1514]/70 flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="font-serif text-4xl md:text-5xl text-white mb-4">Notre Histoire</h1>
            <p className="text-xl text-gray-200 max-w-xl">
              Depuis 2018, Bloom Lingerie habille la femme algérienne avec élégance et qualité.
            </p>
          </div>
        </div>
      </div>

      {/* Story */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="prose prose-lg max-w-none">
          <p className="text-[#6B6A68] text-lg leading-relaxed mb-8">
            <span className="font-serif text-4xl text-[#1A1514] float-left mr-4 mt-1 leading-none">B</span>
            loom Lingerie est née à Alger en 2018. Fondée avec une seule mission : offrir aux femmes algériennes une lingerie élégante, de qualité réelle, à un prix juste.
          </p>
          
          <p className="text-[#6B6A68] text-lg leading-relaxed mb-8">
            Pendant plusieurs années, nous avons opéré des boutiques physiques avant de nous concentrer entièrement sur la vente en ligne pour mieux servir toutes les wilayas d'Algérie.
          </p>

          <p className="text-[#6B6A68] text-lg leading-relaxed mb-8">
            Nous refusons le cheap. Nous refusons l'inaccessible.
          </p>

          <p className="text-[#1A1514] text-xl font-medium leading-relaxed">
            Bloom, c'est le meilleur de la lingerie pour la femme algérienne moderne.
          </p>
        </div>
      </div>

      {/* Values */}
      <div className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-serif text-3xl text-center mb-16">Nos Valeurs</h2>
          
          <div className="grid md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="w-24 h-24 mx-auto mb-8 bg-[#F4E3E1] rounded-full flex items-center justify-center">
                <Sparkles size={40} className="text-[#D4AF37]" />
              </div>
              <h3 className="font-serif text-2xl mb-4">Élégance</h3>
              <p className="text-[#6B6A68] leading-relaxed">
                Des designs raffinés qui allient tendances internationales et goûts locaux. Chaque pièce est pensée pour sublimer la femme qui la porte.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-24 h-24 mx-auto mb-8 bg-[#F4E3E1] rounded-full flex items-center justify-center">
                <Award size={40} className="text-[#D4AF37]" />
              </div>
              <h3 className="font-serif text-2xl mb-4">Qualité</h3>
              <p className="text-[#6B6A68] leading-relaxed">
                Des matières soigneusement sélectionnées pour un confort optimal et une durabilité exceptionnelle. Pas de compromis sur la qualité.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-24 h-24 mx-auto mb-8 bg-[#F4E3E1] rounded-full flex items-center justify-center">
                <HeartHandshake size={40} className="text-[#D4AF37]" />
              </div>
              <h3 className="font-serif text-2xl mb-4">Expérience Client</h3>
              <p className="text-[#6B6A68] leading-relaxed">
                Un service attentionné et personnalisé, de la navigation sur le site jusqu'à la livraison à domicile. Ta satisfaction est notre priorité.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Promise */}
      <div className="py-20 bg-[#1A1514] text-white">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <p className="text-gold text-xs uppercase tracking-[0.3em] mb-4">Notre Promesse</p>
          <h2 className="font-serif text-3xl md:text-4xl mb-8 leading-relaxed">
            "Pas du cheap. Pas du luxe inaccessible. Juste le meilleur rapport qualité-prix."
          </h2>
          <Link 
            to="/shop" 
            className="inline-block border border-gold text-gold px-8 py-4 text-sm font-medium uppercase tracking-wider hover:bg-gold hover:text-[#1A1514] transition-colors"
            data-testid="discover-collection-btn"
          >
            Découvrir la Collection
          </Link>
        </div>
      </div>
    </div>
  );
}
